import OverallSettings from './overall-settings';
import FormLayout from './form-layout';
import Toast from './toast';
import ContentLoading from './content-loading';
import ConsentView from './consent-view';
import Disclaimer from './disclaimer.vue';
import DashboardLayout from './dashboard-layout.vue';
import SiteMap from './map.vue';
import CarouselPageNav from './CarouselPageNav.vue';
import Pagination from './Pagination.vue';

export default {
  install(app) {
    const register = (name, component) => {
      const resolved = component?.default ?? component;
      if (resolved && (typeof resolved === 'object' || typeof resolved === 'function')) {
        app.component(name, resolved);
      }
    };

    register('OverallSettings', OverallSettings);
    register('FormLayout', FormLayout);
    register('Toast', Toast);
    register('ContentLoading', ContentLoading);
    register('ConsentView', ConsentView);
    register('Disclaimer', Disclaimer);
    register('DashboardLayout', DashboardLayout);
    register('SiteMap', SiteMap);
    register('CarouselPageNav', CarouselPageNav);
    register('Pagination', Pagination);
  },
};
